export default {
    'driverPerformanceFunctionTab_escalation_escalation': "Escalation",
    'driverPerformanceFunctionTab_escalation_enableEscalation': "Enable Escalation",
    'driverPerformanceFunctionTab_escalation_escalationSteps': "Escalation Steps",
    'driverPerformanceFunctionTab_escalation_addStep': "Add>>",
    'driverPerformanceFunctionTab_escalation_removeStep': "Remove Step",
    'driverPerformanceFunctionTab_escalation_step': "Step",
    'driverPerformanceFunctionTab_escalation_maximumStepsReached': "Maximum 5 steps allowed",
    'driverPerformanceFunctionTab_escalation_escalationStepRequired': "At least one escalation step is required when escalation is enabled.",
    'driverPerformanceFunctionTab_escalation_labelTheValue': "< Label the Value >",
    'driverPerformanceFunctionTab_escalation_labelLengthError': "Label must be between 4 and 20 characters",
    'driverPerformanceFunctionTab_escalation_labelLengthTooltip': "Length: 4-20 characters",
    'driverPerformanceFunctionTab_escalation_save': "Save",
    'driverPerformanceFunctionTab_escalation_updatedConfiguration': "Configuration Saved Successfully",
    'driverPerformanceFunctionTab_escalation_updatedConfigurationError': "Error Saving Configuration",
    'driverPerformanceFunctionTab_escalation_noStepsAdded': "No escalation steps added yet",
}